module.exports = __webpack_public_path__ + "static/media/arrow-down.43322683.svg";